import React from 'react';
import './Footer.css';
import LogoImg from './logofooter.webp';
import { ReactComponent as InstagramIcon } from './instagram-icon.svg';
import { ReactComponent as WhatsappIcon } from './whatsapp-icon.svg';
import { ReactComponent as FacebookIcon } from './facebook-icon.svg'; // Add your Facebook icon
import { ReactComponent as TiktokIcon } from './tiktok-icon.svg'; // Add your TikTok icon
import { useLanguage } from './LanguageContext';
import { getWhatsAppUrl } from './utils/whatsapp';

function Footer() {
    const { language } = useLanguage();
    const whatsappUrl = getWhatsAppUrl(language);
    const privacyLabel = language === 'ES'
        ? 'Política de Privacidad'
        : language === 'PT'
            ? 'Política de Privacidade'
            : 'Privacy Policy';

    return (
        <footer className="App-footer">
            <div className="footer-shell">
                <div className="footer-column footer-column-left">
                    <div className="footer-address">
                        <span>Calle 15 A #103-5, Ciudad Jardín, Cali, Valle del Cauca</span>
                    </div>
                    <div className="footer-contact">
                        <a href="mailto:contacto@juansalazar.com">contacto@juansalazar.com</a>
                    </div>
                </div>

                <div className="footer-column footer-column-center">
                    <img src={LogoImg} alt="Dr. Juan Salazar" className="footer-logo" loading="lazy" />
                    <div className="footer-privacy">
                        <a href="/privacy-policy">{privacyLabel}</a>
                    </div>
                    <div className="footer-bottom">
                        <span>Clinica Dr. Juan Salazar © Powered by Felipe Castro</span>
                    </div>
                </div>

                <div className="footer-column footer-column-right">
                    <div className="footer-social-grid">
                        <a href="https://www.facebook.com/david.castro.56679/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <FacebookIcon className="social-icon" />
                        </a>
                        <a href="https://www.instagram.com/dr.juanslzar/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <InstagramIcon className="social-icon" />
                        </a>
                        <a href="https://www.tiktok.com/@dr.juanslzar" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                            <TiktokIcon className="social-icon" />
                        </a>
                        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                            <WhatsappIcon className="social-icon" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
